import * as yup from "yup";
import { Max, Min, Validation } from "../utils/Validation.utils";
export const HelpRequestInitialValues = {
    message: ""
};
export const HelpRequestSchema = yup.object().shape({
    message: yup
        .string()
        .min(Min.Message, Validation.Min)
        .max(Max.Message, Validation.Max)
        .required(Validation.Required)
});
